import {
  Rocket,
  Plug,
  Code2,
  HelpCircle,
  TestTube2,
  Settings,
  BookOpen,
  LayoutDashboard,
  MonitorPlay,
  Bot,
} from "lucide-react";

export const DOC_NAV_ICONS = {
  Rocket,
  Plug,
  Code2,
  HelpCircle,
  TestTube2,
  Settings,
  BookOpen,
  LayoutDashboard,
  MonitorPlay,
  Bot,
};

export function resolveDocNavWithIcons(docNav) {
  return docNav.map((group) => ({
    ...group,
    icon: DOC_NAV_ICONS[group.iconKey] || BookOpen,
  }));
}
